import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useFormContext } from 'react-hook-form'

import FormError from '../../typography/FormError'

interface Props {
  errorMessage?: string
  className?: string
}

const FormErrorsHint: React.FC<Props> = (props) => {
  const {
    className,
    errorMessage = 'Some fields have errors. Please fix the fields marked in red.',
  } = props
  const ctx = useFormContext()
  const errors = ctx.errors

  if (!isEmpty(errors)) {
    return <FormError className={className}>{errorMessage}</FormError>
  }

  return null
}

export default FormErrorsHint
